import imgUrlFor from "../functions/imgUrlFor";
import styles from "./SideBySideGallery.module.css";

export default function SideBySideGallery({ value }: { value: any }) {
	return (
		<div className={`${styles.gallerySideBySide} ${styles.gallery}`}>
			{value?.images.map((image: any, index: number) => {
				{
					return (
						<div className={styles.imgWrapper}>
							<img
								width={1600}
								key={index}
								alt={image.alt || " "}
								loading="lazy"
								src={
									imgUrlFor(image)
										.width(1600)
										// .fit("max")
										.auto("format")
										.url() as string
								}
							/>
						</div>
					);
				}
			})}
		</div>
	);
}
